import React, { PropsWithChildren, useContext } from 'react'
import styled from 'styled-components'
import _DropdownBody from '../_DropdownBody'
import { rem } from 'polished'
import clsx from 'clsx'
import { DropdownBehaviourStateContext } from '../DropdownBehaviourContexts'

const Container = styled(_DropdownBody)`
  padding: ${rem(24)};

  &.no-padding {
    padding: 0;
  }
  &.no-top-padding {
    padding-top: 0;
  }
  &.no-bottom-padding {
    padding-bottom: 0;
  }
`

interface Props extends PropsWithChildren, React.RefAttributes<HTMLDivElement> {
  noPaddingOnBody?: boolean
}

function DropdownSheetBody(props: Props) {
  const { children, ref, noPaddingOnBody = false } = props

  const dropdownContext = useContext(DropdownBehaviourStateContext)

  return <Container
    {...props}
    ref={ref}
    className={clsx({
      'no-padding': noPaddingOnBody,
      'no-bottom-padding': !noPaddingOnBody && dropdownContext.hasFooter,
      'no-top-padding': !noPaddingOnBody && dropdownContext.hasHeader,
    })}
  >
    {children}
  </Container>
}

export default DropdownSheetBody
